<template>
  <div>
    <panel title="Informações do Produto">

      <div class="l-row">
        <div class="l-col-5@md">
          <div class="margin">
            <strong>{{ $t('title.label') }}:</strong>
            {{ product.title | attribute }}
          </div>
        </div>
      </div>
    </panel>

    <panel>
      <div class="l-row">
        <form-group :label="$t('ageGroup.label')" :columns="6" :error="getErrorByProductId('ageGroup', product.productId)">
            <select v-model="product.ageGroup" class="form-select">
              <option :value="null">
                Selecione
              </option>
              <option value="adult">
                {{ $t('ageGroup.adult.label') }}
              </option>
              <option value="kids">
                {{ $t('ageGroup.kids.label') }}
              </option>
              <option value="both">
                {{ $t('ageGroup.both.label') }}
              </option>
            </select>
          </form-group>

        <form-group :label="$t('warrantyTime.label')" :columns="6" :error="getErrorByProductId('warrantyTime', product.productId)">
          <div class="form-flex">
            <input class="form-input" type="text" v-model="product.warrantyTime">
            <span class="form-addon">dias</span>
          </div>
        </form-group>

        <form-group :label="$t('brand.label')" :columns="6" :error="getErrorByProductId('brand', product.productId)">
          <div class="form-flex">
            <input class="form-input" type="text" v-model="product.brand">
          </div>
        </form-group>
      </div>
    </panel>

    <panel title="Variações">
      <variation  v-for="variation in product.variations" :key="variation" :variation="variation"/>
    </panel>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { mapGetters } from 'vuex'
  import Variation from '@/components/ProductProvide/Edit/Flexy/Variation'

  export default {
    data: () => ({
      addingImage: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatProduct () {
        return this.product
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getErrorByProductId'
      ])
    },
    components: {
      Panel,
      FormGroup,
      Variation
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-bottom: 10px

  .c-box__body
    border-color: #bde2fb

  .check-box
    border-color: #7872ff

  .c-modalCard__body
    overflow: visible
</style>



// WEBPACK FOOTER //
// Product.vue?5d923aca